var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.53 8.27C17.46 8.26 17.39 8.26 17.32 8.27C15.77 8.22 14.54 6.95 14.54 5.39C14.54 3.8 15.83 2.5 17.43 2.5C19.02 2.5 20.32 3.79 20.32 5.39C20.31 6.95 19.08 8.22 17.53 8.27Z",
    fill: "#B2DDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.79 15.2C19.67 15.95 18.1 16.23 16.65 16.04C17.03 15.22 17.23 14.31 17.24 13.35C17.24 12.35 17.02 11.4 16.6 10.57C18.08 10.37 19.65 10.65 20.78 11.4C22.36 12.44 22.36 14.15 20.79 15.2Z",
    fill: "#B2DDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44 8.27C6.51 8.26 6.58 8.26 6.65 8.27C8.2 8.22 9.43 6.95 9.43 5.39C9.43 3.79 8.14 2.5 6.54 2.5C4.95 2.5 3.66 3.79 3.66 5.39C3.66 6.95 4.89 8.22 6.44 8.27Z",
    fill: "#B2DDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 13.35C6.55 14.32 6.76 15.24 7.14 16.07C5.73 16.22 4.26 15.92 3.18 15.21C1.6 14.16 1.6 12.45 3.18 11.4C4.25 10.68 5.76 10.39 7.18 10.55C6.77 11.39 6.55 12.34 6.55 13.35Z",
    fill: "#B2DDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 16.37C12.04 16.36 11.95 16.36 11.86 16.37C10.02 16.31 8.55 14.8 8.55 12.94C8.56 11.04 10.09 9.5 12 9.5C13.9 9.5 15.44 11.04 15.44 12.94C15.43 14.8 13.97 16.31 12.12 16.37Z",
    fill: "#B2DDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87 18.44C7.36 19.45 7.36 21.11 8.87 22.11C10.59 23.26 13.41 23.26 15.13 22.11C16.64 21.1 16.64 19.44 15.13 18.44C13.42 17.29 10.6 17.29 8.87 18.44Z",
    fill: "#B2DDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/Cluster.161f0b83f9b2aab1fabf8c14d5a3a2cd.svg";
export { ForwardRef as ReactComponent };